import secondaryButtonColorBorderTextRule from '../../../../../common/algorithms/secondary-button-color-border-text-rule';

const primary = (params) => secondaryButtonColorBorderTextRule(params);

export default primary;
